import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import SecondaryHeader from "../../../../Layouts/SecondaryHeader";
import Sidebar from "./PosSidebar";
import OrderSummary from "../../page/OrderSummary/OrderSummary";
import ProductPage from "../../page/ProductPage/ProductPage";
import ProductItemServices from "../../../../services/OrderingServices/ProductItemService";
import toast from "react-hot-toast";
import OrderServices from "../../../../services/OrderingServices/OrderServices";
import TableService from "../../../../services/OrderingServices/TableService";
import SectionService from "../../../../services/OrderingServices/SectionService";
import OrderSummaryModal from "../../page/OrderSummary/OrderSummaryMobile";
import {
  addOrderItem,
  resetOrder,
  resetTableOrder,
  setApiOrderData,
  setOrderData,
  setPlacedOrder,
} from "../../../../slices/Order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import KOTService from "../../../../services/OrderingServices/KOTService";

const PosLayout = () => {
  const dispatch = useDispatch();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState(() => {
    try {
      const item = localStorage.getItem("selectedTable");
      return item && item !== "undefined" ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  });

  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [selectedChildAttributes, setSelectedChildAttributes] = useState([]);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [complementary, setComplementary] = useState(false);
  const [count, setCount] = useState(1);
  const [complementaryCount, setComplimentaryCount] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileOrder, setIsMobileOrder] = useState(false);
  const [billsData, setBillsData] = useState();
  const [data, setData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  const [orderId, setOrderId] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemCounts, setItemCounts] = useState({});
  const [responseOrder, setResponseOrder] = useState([]);
  const orderData = useSelector((state) => state.order.orderData);
  const [isQuantityChanged, setIsQuantityChanged] = React.useState(false);
  const [kotList, setKotList] = useState([]);

  const [placedItems, setPlacedItems] = useState([]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleOrderSummary = () => setIsMobileOrder(!isMobileOrder);
  const kotListRef = useRef();
  const fetchKot = async () => {
    try {
      const response = await KOTService.getList();
      // console.log("🚀 ~ fetchKot ~ response:", response);
      setKotList(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchKot();
  }, []);
  const handleAddToCart = (item) => {
    console.log("🚀 ~ handleAddToCart ~ item:", item);
    const items = item?.id || selectedItem?.id;
    if (!items || !selectedTable?.id) {
      toast.error("Please select a table and item first.");
      return;
    }

    // Map selectedChildAttributes to include required fields
    const updatedChildren = selectedChildAttributes?.map((child) => ({
      productId: child?.productId,
      productName: child?.productName || "", // Fallback to selectedItem.name
      quantity: child?.quantity || 0, // Default to 0 if quantity is not provided
      productPrice: child?.productPrice || 0, // Fallback to selectedItem.price
      attributes: Array.isArray(child?.attributes)
        ? child?.attributes.map((attr) => ({
            title: attr?.title,
            value: attr?.value || 0, // Ensure value is a number or 0
            spicyLevel: attr?.spicyLevel || 0, // Include spicyLevel
          }))
        : [],
    }));

    const newItem = {
      productId: selectedItem?.id || item?.id,
      quantity: complementary ? 0 : count,
      complimentaryQuantity: complementary ? count : 0,
      note: notes || "",
      productName: selectedItem?.name || item?.name,
      productPrice: selectedItem?.price || item?.price,
      unitName: selectedItem?.unitName || item?.unitName,
      remarks: notes || "",
      isComplimentary: complementary,
      attributes: Object.values(selectedAttributes).map((attrGroup) => {
        const option = attrGroup.Option;
        return {
          title: option?.title,
          value: option?.value,
          spicyLevel: option?.spicyLevel || 0, // Include spicyLevel from parent attributes
        };
      }),
      finalQuantity: count,
      image: selectedItem?.image || "https://via.placeholder.com/60",
      isLocalItem: true,
      children: updatedChildren, // Use updated children with required fields including spicyLevel
    };
    console.log("🚀 ~ handleAddToCart ~ newItem:", newItem);

    try {
      setLoading(true);

      const currentOrder = orderData[selectedTable.id] || {
        tableId: selectedTable.id,
        remarks: "",
        items: [],
      };

      const existingItemIndex = currentOrder.items.findIndex(
        (item) =>
          item.productId === newItem.productId &&
          JSON.stringify(item.attributes) ===
            JSON.stringify(newItem.attributes) &&
          JSON.stringify(item.children) === JSON.stringify(newItem.children) // Also compare children
      );

      let updatedItems;
      if (existingItemIndex >= 0) {
        updatedItems = [...currentOrder.items];
        const existingItem = updatedItems[existingItemIndex];

        updatedItems[existingItemIndex] = {
          ...existingItem,
          quantity: existingItem.quantity + newItem.quantity,
          complimentaryQuantity:
            existingItem.complimentaryQuantity + newItem.complimentaryQuantity,
          finalQuantity:
            existingItem.quantity +
            newItem.quantity +
            existingItem.complimentaryQuantity +
            newItem.complimentaryQuantity,
          note: newItem.note || existingItem.note,
          remarks: newItem.remarks || existingItem.remarks,
          isComplimentary:
            existingItem.complimentaryQuantity + newItem.complimentaryQuantity >
            0,
          children: updatedChildren.length
            ? updatedChildren
            : existingItem.children || [], // Update children with spicyLevel
        };
      } else {
        updatedItems = [
          ...currentOrder.items,
          {
            ...newItem,
            finalQuantity: newItem.quantity + newItem.complimentaryQuantity,
            isComplimentary: newItem.complimentaryQuantity > 0,
          },
        ];
      }

      dispatch(
        setOrderData({
          [selectedTable.id]: {
            ...currentOrder,
            isNewItem: true,
            items: updatedItems,
          },
        })
      );

      toast.success(
        `Item added to cart ${complementary ? "(Complementary)" : ""}.`
      );
      setSelectedItem({});
      fetchTable();
      resetModalState();
    } catch (error) {
      console.error("Add to cart failed:", error);
      toast.error("Failed to add item.");
    } finally {
      setLoading(false);
    }
  };

  const handlePlaceOrder = async () => {
    const tableId = selectedTable?.id;
    const rawOrder = orderData[tableId];
    console.log("🚀 ~ handlePlaceOrder ~ rawOrder:", rawOrder);

    if (!rawOrder || !rawOrder.items.length) {
      toast.error("Cart is empty.");
      return;
    }

    const formattedOrder = {
      tableId: rawOrder.tableId,
      remarks: rawOrder.remarks || "",
      items: rawOrder.items.map((item, index) => {
        const itemKey = `${tableId}-${index}`;
        const quantity =
          itemCounts[itemKey] !== undefined
            ? itemCounts[itemKey]
            : item.quantity || 0;
        const complimentaryQuantity = item.complimentaryQuantity || 0;

        return {
          productId: item.productId,
          quantity,
          complimentaryQuantity,
          note: item.note || "",
          remarks: item.remarks || "",
          children: Array.isArray(item.children)
            ? item.children.map((child) => ({
                productName: child.productName || "",
                quantity: child.quantity || 0,
                productPrice: child.productPrice || 0,
                attributes: Array.isArray(child.attributes)
                  ? child.attributes.map((attr) => ({
                      title: attr.title,
                      value: attr.value || 0,
                      spicyLevel: attr.spicyLevel || 0,
                    }))
                  : [],
              }))
            : [],
          isComplimentary: quantity > 0 ? false : true,
          attributes: Array.isArray(item.attributes)
            ? item.attributes.map((attr) => ({
                title: attr.title,
                value: attr.value,
                spicyLevel: attr.spicyLevel || 0,
              }))
            : [],
        };
      }),
    };
    // console.log("🚀 ~ handlePlaceOrder ~ formattedOrder:", formattedOrder);

    try {
      setLoading(true);
      console.log(
        "🚀 ~ handlePlaceOrder ~ payload sent to backend:",
        formattedOrder
      );
      const response = await ProductItemServices.order(formattedOrder);

      const mappedOrder = {
        orderId: response.id,
        orderRefrenceId: response.orderRefrenceId,
        totalAmount: response.totalAmount,
        discountAmount: response.discountAmount,
        taxAmount: response.taxAmount,
        grandTotal: response.grandTotal,
        paymentStatus: response.paymentStatus,
        orderStatus: response.orderStatus,
        remarks: response.remarks || "",
        tableId,
        items: response.orderDetails.map((item) => ({
          id: item?.id,
          productId: item.productId,
          quantity: item.quantity,
          complimentaryQuantity: item.complimentaryQuantity,
          finalQuantity: item.quantity + item.complimentaryQuantity,
          remarks: item.remarks || "",
          isComplimentary: item.isComplimentary,
          attributes: Array.isArray(item.attributes)
            ? item.attributes.map((attr) => ({
                title: attr.title,
                value: attr.value,
                spicyLevel: attr.spicyLevel || 0, // Preserve spicyLevel from response
              }))
            : [],
          productName: item.productName,
          productPrice: item.productPrice,
          image: item.image || "https://via.placeholder.com/60",
          orderItemStatus: item?.orderItemStatus,
          printingRemainingQuantity: item?.printingRemainingQuantity,
          printedQuantity: item?.printedQuantity,
          children: Array.isArray(item.children)
            ? item.children.map((child) => ({
                productName: child.productName || "", // Ensure productName
                quantity: child.quantity || 0, // Ensure quantity
                productPrice: child.productPrice || 0, // Ensure productPrice
                attributes: Array.isArray(child.attributes)
                  ? child.attributes.map((attr) => ({
                      title: attr.title,
                      value: attr.value || 0, // Ensure value is a number or 0
                      spicyLevel: attr.spicyLevel || 0, // Preserve spicyLevel from response
                    }))
                  : [],
              }))
            : [],
        })),
      };

      dispatch(
        setOrderData({
          [tableId]: mappedOrder,
        })
      );
      setIsQuantityChanged(null);
      dispatch(resetTableOrder(tableId));
      toast.success("Order created successfully.");
      fetchOrder();
      fetchTable();
      kotListRef.current?.refreshKot();

      resetModalState();
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrder = async () => {
    if (!selectedTable?.id) return;
    setLoading(true);
    setError(null);

    try {
      const response = await OrderServices.getByTable(selectedTable?.id);
      if (!response?.id) return;

      const placedItems = (response?.orderDetails || []).map((item) => ({
        id: item?.id,
        productId: item?.productId,
        quantity: item?.quantity,
        note: item?.note || "",
        remarks: item?.remarks || "",
        isComplimentary: item?.isComplimentary || false,
        attributes: Array.isArray(item?.attributes)
          ? item?.attributes?.map((attr) => ({
              title: attr?.title,
              value: attr?.value,
              spicyLevel: attr?.spicyLevel || 0, // Preserve spicyLevel
            }))
          : [],
        productName: item?.productName,
        productPrice: item?.productPrice,
        complimentaryQuantity: item?.complimentaryQuantity,
        finalQuantity: item?.finalQuantity,
        image: item?.image || "https://via.placeholder.com/60",
        orderItemStatus: item?.orderItemStatus,
        printingRemainingQuantity: item?.printingRemainingQuantity,
        printedQuantity: item?.printedQuantity,
        children: Array.isArray(item?.children)
          ? item?.children?.map((child) => ({
              productName: child?.productName || "",
              quantity: child?.quantity || 0,
              productPrice: child?.productPrice || 0,
              attributes: Array.isArray(child.attributes)
                ? child?.attributes?.map((attr) => ({
                    title: attr.title,
                    value: attr.value || 0,
                    spicyLevel: attr.spicyLevel || 0, // Preserve spicyLevel for children
                  }))
                : [],
            }))
          : [],
      }));
      console.log("🚀 ~ fetchOrder ~ placedItems:", placedItems);

      //local state saving
      setPlacedItems(placedItems);

      // 🔄 Merge unplaced items from localStorage
      const cartOrders = JSON.parse(localStorage.getItem("cartOrders")) || {};
      const localItems =
        cartOrders[selectedTable.id]?.items?.filter((item) => !item.id) || [];

      const mergedItems = [...placedItems, ...localItems];
      console.log("🚀 ~ fetchOrder ~ mergedItems:", mergedItems);

      const mappedOrder = {
        orderId: response?.id,
        tableId: selectedTable?.id,
        orderRefrenceId: response?.orderRefrenceId,
        totalAmount: response?.totalAmount,
        discountAmount: response?.discountAmount,
        taxAmount: response?.taxAmount,
        grandTotal: response?.grandTotal,
        paymentStatus: response?.paymentStatus,
        orderStatus: response?.orderStatus,
        remarks: response?.remarks || "",
        items: mergedItems,
      };

      dispatch(setApiOrderData({ [selectedTable.id]: mappedOrder }));
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError("Failed to fetch order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSection = async () => {
    try {
      const response = await SectionService.getList();
      setSectionData(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTable = async () => {
    setLoading(true);
    try {
      const response = await SectionService.detail(selectedSection?.value);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetModalState = () => {
    setIsModalOpen(false);
    setComplementary(false);
    setCount(1);
    setSelectedAttributes([]);
    setNotes("");
  };

  useEffect(() => {
    if (selectedTable?.id) {
      fetchOrder();
    }
  }, [selectedTable?.id]);

  useEffect(() => {
    fetchSection();
  }, []);

  useEffect(() => {
    if (selectedSection?.value) fetchTable();
  }, [selectedSection?.value]);
  useEffect(() => {
    if (selectedTable?.id) {
      localStorage.setItem("selectedTable", JSON.stringify(selectedTable));
      fetchOrder();
    }
  }, [selectedTable?.id]);

  return (
    <div className="container-xxl " style={{ height: "100vh" }}>
      <Row>
        <Col
          md={7}
          lg={8}
          className=" d-flex flex-column"
          style={{
            height: "100vh",
          }}
        >
          <div className="sticky-top ">
            <SecondaryHeader
              toggleSidebar={toggleSidebar}
              sectionData={sectionData}
              setSelectedSection={setSelectedSection}
              selectedSection={selectedSection}
              data={data}
              setSelectedTable={setSelectedTable}
              selectedTable={selectedTable}
              kotListRef={kotListRef}
              setIsTableOpen={setIsTableOpen}
              isTableOpen={isTableOpen}
              kotList={kotList}
              setKotList={setKotList}
            />
            {/* Optionally hide sidebar below md */}
            <div className="d-none d-md-block">
              <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
            </div>
          </div>
          {/* Product Page Scrolls */}
          <div className="flex-grow-1 overflow-y-auto overflow-x-hidden ">
            <ProductPage
              setSelectedItem={setSelectedItem}
              selectedItem={selectedItem}
              setCount={setCount}
              setComplimentaryCount={setComplimentaryCount}
              count={count}
              setSelectedAttributes={setSelectedAttributes}
              selectedAttributes={selectedAttributes}
              handleAddToCart={handleAddToCart}
              setNotes={setNotes}
              notes={notes}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setComplementary={setComplementary}
              complementary={complementary}
              loading={loading}
              setSelectedTable={setSelectedTable}
              selectedTable={selectedTable}
              toggleOrderSummary={toggleOrderSummary}
              orderData={orderData}
              setSelectedChildAttributes={setSelectedChildAttributes}
              selectedChildAttributes={selectedChildAttributes}
            />
          </div>
        </Col>

        <Col
          md={5}
          lg={4}
          className="pt-lg-2 pt-md-2 d-none d-lg-block d-md-block"
          style={{
            height: "100vh",
          }}
        >
          <OrderSummary
            orderData={
              responseOrder[selectedTable?.id] ? responseOrder : orderData
            }
            setOrderId={setOrderId}
            orderId={orderId}
            data={data}
            fetchTable={fetchTable}
            sectionData={sectionData}
            setSelectedSection={setSelectedSection}
            selectedSection={selectedSection}
            fetchOrder={fetchOrder}
            setSelectedTable={setSelectedTable}
            selectedTable={selectedTable}
            handlePlaceOrder={handlePlaceOrder}
            billData={billsData}
            itemCounts={itemCounts}
            setItemCounts={setItemCounts}
            setIsQuantityChanged={setIsQuantityChanged}
            isQuantityChanged={isQuantityChanged}
            placedLoading={loading}
            placedItems={placedItems}
            fetchKot={fetchKot}
          />
        </Col>
      </Row>
      {isMobileOrder && (
        <OrderSummaryModal
          isOpen={isMobileOrder}
          toggle={toggleOrderSummary}
          // setOrderData={setOrderData}
          orderData={
            responseOrder[selectedTable?.id] ? responseOrder : orderData
          }
          setOrderId={setOrderId}
          orderId={orderId}
          data={data}
          fetchTable={fetchTable}
          sectionData={sectionData}
          setSelectedSection={setSelectedSection}
          selectedSection={selectedSection}
          fetchOrder={fetchOrder}
          setSelectedTable={setSelectedTable}
          selectedTable={selectedTable}
          handlePlaceOrder={handlePlaceOrder}
          itemCounts={itemCounts}
          setItemCounts={setItemCounts}
          setIsQuantityChanged={setIsQuantityChanged}
          isQuantityChanged={isQuantityChanged}
          placedLoading={loading}
          fetchKot={fetchKot}
        />
      )}
    </div>
  );
};

export default PosLayout;
